

// tone filter
document.addEventListener("DOMContentLoaded", () => {
  const cartNotification = document.querySelector("cart-notification")
  const nextButton = document.getElementById('nextbtn');
  const backButtons = document.querySelectorAll('.product-card-back-btn');
  const shopNowButton = document.getElementById('shopbtn');
  

  const tonesContainer = document.getElementById('tonesContainer');
  const toneBlocks = document.querySelectorAll('.tone-block');

  const productCardsContainer = document.getElementById('productCardsContainer');
  const productCardVariants = document.querySelectorAll('.product-card-variants');
  const productCards = document.querySelectorAll('#addOnsProductContainer .product-card');

  const optionsContainer = document.getElementById('optionsContainer');
  const containerArray = [];
  const items = []

  let nextContainer = 0


  toneBlocks.forEach((block, i) => {
    block.addEventListener('click', () => {
      const dataFilter = block.getAttribute('data-filter') 
      
      optionsContainer.setAttribute('data-shade', dataFilter);
      productCardVariants[i].setAttribute('data-filter', dataFilter);
      tonesContainer.classList.add("hidden")
      productCardsContainer.classList.remove('hidden');
      productCardsContainer.style.opacity = 1;
      nextContainer = 1;
      filterVariants(dataFilter);
    });
  })

  const filterVariants = (filter) => {
    const variantItems = document.querySelectorAll(".product-card-variants-item");
    
    variantItems.forEach(function(item) {
      const shadeType = item.getAttribute("data-shade-type");
      const shadeTypeArray = shadeType.split(',')
      if(shadeTypeArray.includes(filter)){
        item.addEventListener("click", onVariantClick);
      }else{
        item.classList.add("hidden");
      }
    });
  }
  
  const onVariantClick = (e) => {
    const input = e.target;
    const variant = e.target.value;

    input.classList.toggle("selected");

    const index = items.findIndex((item) => item.id === variant);

    if (input.classList.contains('selected')) {
      if (index === -1) {
        items.push({id: variant, quantity: 1});
        input.checked = true
      }
    } else {
      if (index !== -1) {
        items.splice(index, 1);
        input.checked = false
      }
    }

    nextButton.classList.remove('hidden');
    backButtons[0].classList.remove('hidden')
  }

  const handProductCardClick = (e, id) => {
    if (!id) return;
    
    
    const el = document.querySelector(`[data-product="${id}"]`);
    
    if (el) {
      const disabled = el.getAttribute('aria-disabled');
      if (disabled === "true") return;
      
      el.classList.toggle("selected");
      const index = items.findIndex((item) => item.id === id);
      if (el.classList.contains('selected')) {
        if (index === -1) {
          items.push({id: id, quantity: 1});
        }
      } else {
        if (index !== -1) {
          items.splice(index, 1);
        }
      }
    }

  }
  
  const handleNextClick = () => {
    nextContainer = 2;
    containerArray[nextContainer - 1].classList.add('hidden');
    containerArray[nextContainer].classList.remove('hidden');
  }


  const handleBackClick = (e) => {

    const ariaLabel = e.target.ariaLabel

    console.log(ariaLabel)
    switch (ariaLabel) {
      case "product-container-back":
        containerArray[0].classList.remove('hidden');
        containerArray[1].classList.add('hidden');
        break;
        
      case "addons-container-back":
        console.log("TEST")
        containerArray[1].classList.remove('hidden');
        containerArray[2].classList.add('hidden');
        break;

      default:
        break;
    }

  }
  
  const handleShopNowClick = async () => {

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = {
      items: items,
      sections: cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    };
    // const formData = new FormData();
    // formData.append('items', items);
    // formData.append('sections', cartNotification.getSectionsToRender().map((section) => section.id));
    // formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(routes.cart_add_url, config)
    .then(response => response.json())
    .then((data) => {
      const {description, status, message, items} = data
      if(status && status === 422){
        console.log(message, description)
        return;
      }

      cartNotification.renderContents(data);
      document.querySelector('.cart-items')?.classList.toggle('is-empty', data.quantity === 0);

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  optionsContainer.childNodes.forEach((el) => {
    if(el instanceof HTMLDivElement){
      containerArray.push(el)
    }
  })

  productCards.forEach((el) => {
    if(el.className === "product-card"){
      const id = el.getAttribute('data-product');
      el.addEventListener('click', (e) => handProductCardClick(e, id))
    }
  })

  backButtons.forEach((el, index) => {
    el.addEventListener("click", handleBackClick)
  })

  nextButton.addEventListener('click', handleNextClick)
  shopNowButton.addEventListener('click', handleShopNowClick)
});